import { v4 as uuidv4 } from 'uuid';

export const defaultValueList = [{ id: uuidv4(), value: '' }];
